export default __webpack_public_path__ + "static/brand-logo-white-22831407037feabe5f6510a32dd976d7.svg";